import React from 'react';
import { func_cookieSetting, isDateValid, isNumberOrStringValid, isNumberValid, isStringTrimNotEmpty, reformatNumberWithCommas } from 'functions';

export function useTableColumns() {

    function getColumn_numbering() {
        let columnClassName = "table__column-numbering";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "",
            id: "numbering",
            accessor: "numbering",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                return (
                    <div className={"noWrap-text-ellipsis"}>{isNumberValid(props?.row?.index)? props?.row?.index + 1:""}</div>
                );
            },
            width: 100
        }
    }

    function getColumn_siteID() {
        let columnClassName = "table__column-site-id";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Site ID",
            id: "siteID",
            accessor: "SiteID",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 100
        }
    }

    function getColumn_locationID() {
        let columnClassName = "table__column-location-id";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Location ID",
            id: "locationID",
            accessor: "LocationID",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 300
        }
    }

    function getColumn_location() {
        let columnClassName = "table__column-location";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Location",
            id: "location",
            accessor: "LocationName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 400
        }
    }

    function getColumn_totalSalesTransaction() {
        let columnClassName = "table__column-total-sales-transaction";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Total Sales Transaction",
            id: "totalSalesTransaction",
            accessor: "TotalSalesTransaction",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberOrStringValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{reformatNumberWithCommas(value_formatted)}</div>
                );
            },
            width: 200
        }
    }


    return [
        getColumn_numbering(),
        getColumn_siteID(),
        getColumn_locationID(),
        getColumn_location(),
        getColumn_totalSalesTransaction(),
    ]
}